import "../assets/css/App.css";
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import {
  Box,
  AppBar,
  Toolbar,
  Tooltip,
  Container,
  Typography,
  IconButton,
} from "@mui/material";
import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  useDisclosure,
  DrawerContent,
  DrawerOverlay,
  DrawerCloseButton,
} from "@chakra-ui/react";
import { useNavigate, Outlet } from "react-router-dom";
import theme from "../assets/themes/theme";
import { ThemeProvider } from "@mui/material";
import logoST from "../assets/images/LogoSTL.svg";
import logoLolify from "../assets/images/Lilofy_blanco.png";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

const LayoutExternal = () => {
  const navigate = useNavigate();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();

  return (
    <Fragment>
      <ThemeProvider theme={theme}>
        <Box minHeight={"95vh"}>
          <Box>
            <AppBar position="static">
              <Toolbar className="justify-content-between">
                <img src={logoLolify} className="logoNav" alt="logo" />
                <Typography
                  variant="h6"
                  noWrap
                  sx={{
                    mr: 2,
                    display: { xs: "none", md: "flex" },
                    fontFamily: "Inter",
                    fontWeight: 400,
                    color: "inherit",
                    flexGrow: 1,
                  }}
                >
                  Conectando la oferta y la demanda
                </Typography>
                <Tooltip title="Rastrear Envío">
                  <IconButton
                    sx={{ color: "white", fontSize: "1.3rem" }}
                    onClick={() => navigate("/Rastreo")}
                  >
                    <LocalShippingIcon ref={btnRef} /* onClick={onOpen} */ />
                  </IconButton>
                </Tooltip>
                {/* <Drawer
                  isOpen={isOpen}
                  onClose={onClose}
                  placement="right"
                  finalFocusRef={btnRef}
                  size="md"
                >
                  <DrawerOverlay className="drawer-overlay" />

                  <DrawerContent
                    h="100%"
                    bg={"white"}
                    w="70% !important"
                    sx={{ overflowY: "auto" }}
                  >
                    <DrawerCloseButton
                      _focus={{ boxShadow: "none" }}
                      _hover={{ boxShadow: "none" }}
                      sx={{
                        position: "absolute",
                        top: "0.5rem",
                        right: "0.75rem",
                      }}
                    />
                    <DrawerHeader p={"20px"}>
                      <Typography variant="h6">Rastrear Envío</Typography>
                    </DrawerHeader>
                    <DrawerBody px="1rem" py="1rem">
                      <RastreoEnvio />
                    </DrawerBody>
                  </DrawerContent>
                </Drawer> */}
              </Toolbar>
            </AppBar>
          </Box>
          <Container>
            <Outlet />
          </Container>
        </Box>

        <footer
          style={{
            color: "gray",
            width: "100%",
            height: "5vh",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
          }}
        >
          <Box
            display="flex"
            flexWrap="wrap"
            alignItems="center"
            justifyContent={"center"}
          >
            <a href="https://www.axsistec.com/web/Index.html">
              <Typography
                color="textSecondary"
                component="p"
                variant="caption"
                gutterBottom={false}
              >
                Powered by Axsis Tecnología © 2023.
              </Typography>
            </a>
          </Box>
        </footer>

        {/* <Fab color="primary" aria-label="info" sx={fabStyle}>
            <QuestionMarkIcon />
        </Fab> */}
      </ThemeProvider>
    </Fragment>
  );
};

export default LayoutExternal;
